<template>
  <div>
    <Breadcrumbs :title="title"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">

          <div class="card">
            <div class="card-header">
              <h5>Top Gain</h5>
              <span></span>
            </div>

            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>

                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="table-responsive datatable-vue">
                <b-table
                    show-empty
                    stacked="md"
                    :items="gain"
                    :fields="tablefields"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFilteredG"
                >
                </b-table>
              </div>

              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRowsG"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>


            </div>

          </div>

          <div class="card">
            <div class="card-header">
              <h5>Top Lose</h5>
              <span></span>
            </div>
            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                    show-empty
                    stacked="md"
                    :items="lose"
                    :fields="tablefields"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFilteredL"
                >
                </b-table>
              </div>
              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRowsL"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <h5>Top Volatility</h5>
              <span></span>
            </div>
            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                    show-empty
                    stacked="md"
                    :items="volatile"
                    :fields="tablefieldsV"
                    :filter="filter"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFilteredV"
                >
                </b-table>
              </div>
              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRowsV"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>


            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      tablefields: [
        { key: 'id', label: 'ID', sortable: true, },
        { key: 'name', label: 'Name', sortable: true, },
        { key: 'market_cap', label: 'Market Cap', sortable: true, },
        { key: 'today_change', label: 'Change', sortable: true, },
        { key: 'today_open', label: 'Open', sortable: true, },
        { key: 'today_high', label: 'High', sortable: true, },
        { key: 'today_low', label: 'Low', sortable: true, },
        { key: 'today_close', label: 'Close', sortable: true, },
        { key: 'today_volume', label: 'Volume', sortable: true, },
      ],
      tablefieldsV: [
        { key: 'id', label: 'ID', sortable: true, },
        { key: 'stock', label: 'Name', sortable: true, },
        { key: 'open', label: 'Open', sortable: true, },
        { key: 'high', label: 'High', sortable: true, },
        { key: 'low', label: 'Low', sortable: true, },
        { key: 'close', label: 'Close', sortable: true, },
        { key: 'volume', label: 'Volume', sortable: true, },
        { key: 'volatility', label: 'Volatility', sortable: true, },
        { key: 'volatility_pct', label: 'Percent', sortable: true, },
      ],
      gain: [],
      lose: [],
      volatile: [],

      filter: null,

      totalRowsG: 1,
      totalRowsL: 1,
      totalRowsV: 1,
      currentPage: 1,
      perPage: 30,
      pageOptions: [30, 200, 1000],
    }
  },
  computed: {
    title: function () { return 'Active Stocks Today' },
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
    }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchTopGain()
      this.fetchTopLose()
      this.fetchTopVolatile()
    },
    fetchTopGain() {
      this.$http.get('/api/stock/top/gain')
          .then(({data}) => {
            this.gain = data.gain.map(g => ({ ...g, today_change:Math.round((g.today_change-1)*100)+'%' }))
            this.totalRowsG = this.gain.length
          })
          .catch(e => console.log(e.message))
    },
    fetchTopLose() {
      this.$http.get('/api/stock/top/lose')
          .then(({data}) => {
            this.lose = data.lose.map(g => ({ ...g, today_change:Math.round((g.today_change-1)*100)+'%' }))
            this.totalRowsL = this.lose.length
          })
          .catch(e => console.log(e.message))
    },
    fetchTopVolatile() {
      this.$http.get('/api/stock/top/volatile')
          .then(({data}) => {
            this.volatile = data.volatile.map(g => ({ ...g, volatility:Math.round(g.volatility*100)/100, volatility_pct:Math.round(g.volatility_pct*10)/10+'%' }))
            this.totalRowsV = this.volatile.length
          })
          .catch(e => console.log(e.message))
    },
    onFilteredG(filteredItems) {
      this.totalRowsG = filteredItems.length
      this.currentPage = 1
    },
    onFilteredL(filteredItems) {
      this.totalRowsL = filteredItems.length
      this.currentPage = 1
    },
    onFilteredV(filteredItems) {
      this.totalRowsV = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>